export default __webpack_public_path__ + "static/media/resume.c4913dd8.pdf";